import {
    useQueues,
    useUsers,
} from '../../../../hooks/ninchat'
import {ArrowsLeftRightIcon} from '../../../Icon'
import Attribute from '../Attribute'
import {MessageProps} from '../../types'
import React from 'react'
import {useTranslation} from 'react-i18next'

const InfoTransferMessage = (props: MessageProps): React.ReactElement => {
    const {
        message_type,
        queue_id,
        user_id,
    } = props

    const {t} = useTranslation()

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const queueName = useQueues([queue_id!], false)?.[queue_id!]?.queue_attrs?.name

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const userAttrs = useUsers([user_id!])?.[user_id!]?.user_attrs

    const userName = userAttrs && (userAttrs.name ? userAttrs.name : userAttrs.deleted ? t('Deleted user') : t('Unnamed user'))

    return (
        <>
            {message_type === 'ninchat.com/info/transfer/target' &&
                <Attribute
                    icon={ArrowsLeftRightIcon}
                    text={t('{{userName}} was transferred to {{queueName}} queue', {
                        queueName,
                        userName,
                    })}
                    type='success'
                />}
            {message_type === 'ninchat.com/info/transfer/source' &&
                <Attribute
                    icon={ArrowsLeftRightIcon}
                    text={t('{{userName}} transferred customer from {{queueName}} queue', {
                        queueName,
                        userName,
                    })}
                    type='success'
                />}
        </>
    )
}

export default InfoTransferMessage
